"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
function Label(_a) {
    var { children, required } = _a, props = __rest(_a, ["children", "required"]);
    return ((0, preact_1.h)("label", Object.assign({ className: 'block mb-2 font-bold text-base sm:text-lg' }, props),
        children,
        required && (0, preact_1.h)("abbr", { title: 'required', className: 'no-underline text-error' }, " *")));
}
exports.default = Label;
